import { render } from "./Marquee.vue?vue&type=template&id=7ea9ace4&scoped=true&ts=true"
import script from "./Marquee.vue?vue&type=script&lang=ts"
export * from "./Marquee.vue?vue&type=script&lang=ts"

import "./Marquee.vue?vue&type=style&index=0&id=7ea9ace4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea9ace4"]])

export default __exports__